module.exports = __webpack_public_path__ + "img/status-eveywhere.92ac30ba.png";